<template>
    <article v-if="item" class="product-item">
        <figure class="image" v-if="img">
            <router-link :to="link">
                <img :src="img">
            </router-link>
        </figure>
        <div class="col">
            <router-link :to="link">
                <h2 class="post-title" v-html="title"></h2>
            </router-link>
            <p class="outofstock" v-if="stock_status === 'outofstock'">Out of stock</p>
            <p class="price" v-else-if="price" v-html="price"></p>

      
            
        </div>
    </article>
</template>

<script>

export default {
    name: 'product-item',
 

    props: {
        item: {
            type: Object,
            default: false,
        },
    },

    data() {
        return {
            img: '',
            title: '',
            link: '',
            price: '',
            stock_status: '',
        }
    },

    mounted() {
        if (this.item.post_title) {
            this.title = this.item.post_title;
        } else {
            this.title = this.item.title.rendered;
        }
        
        this.link = this.item.link.replace(window.globals.home_url, this.$base_url);
        this.img = this.item.featured_image.medium;
        this.price = '£' + Number(this.item.price).toFixed(2);
        this.stock_status = this.item.stock_status;

    },
}
</script>

<style lang="scss">
    .product-item {
        position: relative;
        // background: white;
        padding: var(--padding-50);
        width: 25%;
        box-sizing: border-box;

        .image {
            width: 100%;
            position: relative;
            box-sizing: border-box;
            display: block;

            a {
                display: block;
                position: relative;

                &::before {
                    content: '';
                    display: block;
                    padding: 0 0 100%;
                }
            }
            

            img {
                width: 100%;
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .col {
            box-sizing: border-box;
            font-size: var(--small-size);
        }

        .post-title {
            margin: var(--padding-25) 0 0;
            // font-family: var(--title-font);
        }

        .outofstock {
            color: var(--gray);
        }

        &:hover {
            h2, p {
                text-decoration: underline;
            }
        }

    }

    @media only screen and (max-width: 767px) {
        .product-item {
            width: 50%;
            box-sizing: border-box;


            .col {
                font-size: var(--large-size);
            }



        }
    }

</style>
